<template>
  <ul class="burger-menu-list">
    <li
      v-for="(item, index) in burgerItems"
      :key="index"
      class="burger-menu-list__item"
    >
      <BurgerItem
        :item="item"
        @click-menu-item="emit('click-menu-item', $event)"
      />
    </li>
    <li v-if="showBuildInfo">
      <BuildInfo class="build-info" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
  import BurgerItem from '~/components/TheHeader/Burger/BurgerItem.vue';
  import { useMenusStore } from '~/store/menus';
  import BuildInfo from '@devhacker/shared/features/build-info/BuildInfo.vue';
  import buildBuildInfo from '@devhacker/shared/features/build-info/buildBuildInfo';

  const emit = defineEmits(['click-menu-item']);

  const burgerItems = useMenusStore().burgerItems;
  const showBuildInfo = ref(false);
  const { $isDebug } = useNuxtApp();

  onMounted(() => {
    // выводим версию билда в консоль
    Object.assign(window, { buildInfo: buildBuildInfo() });

    if ($isDebug) showBuildInfo.value = true;
  });
</script>

<style lang="scss" scoped>
  .burger-menu-list {
    &__item {
      word-break: break-word;
      // * нижний бордер при 100% наползает на бордер слева менюшки
      width: calc(100% - 4px);
      margin: 0 auto;
      &:not(:last-child) {
        border-bottom: 1px solid $stroke-color--1;
      }
    }
  }

  .build-info {
    padding: 12px 48px;

    @include big-tablet {
      padding: 12px 24px;
    }
  }
</style>
